import React from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';

const Table = ({ payments }) => {
    const empty = (payments.length === 0);
    if (empty) {
        return (
            <div className="rounded-0 alert alert-warning m-0">
                Nenhum pagamento foi encontrado.
            </div>
        );
    } else {
        return (
            <div className="table-responsive">
                <table className="table table-hover align-items-center table-flush">
                    <TableHead/>
                    <TableBody payments={payments}/>
                </table>
            </div>
        )
    }
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/Pages/Payments/Table/index.js